
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { OpenCloseType } from '@models/users/open-close-type.enum';
import { RequestTopic } from '@models/users/request-topic.dto';
import { UserRequest } from '@models/users/user-request.dto';

import { AccountService } from '@services/account.service';
import { ContactService } from '@services/contact.service';

@Component({
  selector: 'ebs-problem-report-page',
  templateUrl: './problem-report-page.component.html',
  styleUrls: ['./problem-report-page.component.scss'],
})
export class ProblemReportPageComponent {
  /* =====================================================
     FORM
     ===================================================== */

  formGroupTopic: FormGroup;
  formGroupDesc: FormGroup;

  /* =====================================================
     STATO PAGINA
     ===================================================== */

  public isTopicSelection = true;
  public submitting = false;

  /* =====================================================
     DATI
     ===================================================== */

  public topics: RequestTopic[] = [];

  public description = '';
  public selectedTopic: RequestTopic | null = null;

  /* =====================================================
     COSTRUTTORE
     ===================================================== */

  constructor(
    private contactService: ContactService,
    private accountService: AccountService,
    private router: Router,
  ) {
    this.formGroupTopic = new FormGroup({
      topic: new FormControl<RequestTopic | null>(
        null,
        {
          validators: [Validators.required],
        },
      ),
    });

    this.formGroupDesc = new FormGroup({
      description: new FormControl<string>(
        '',
        {
          nonNullable: true,
          validators: [Validators.required],
        },
      ),
    });

    this.loadTopics();
  }

  /* =====================================================
     CARICAMENTO ARGOMENTI
     ===================================================== */

  private loadTopics(): void {
    this.contactService
      .getTopicList()
      .subscribe({
        next: (topics) => {
          this.topics = topics;
        },

        error: (error) => {
          console.error(
            'Errore caricamento argomenti:',
            error,
          );

          this.topics = [];
        },
      });
  }

  /* =====================================================
     SELEZIONE ARGOMENTO
     ===================================================== */

  public selectTopic(topic: RequestTopic): void {
    if (this.submitting) {
      return;
    }

    this.selectedTopic = topic;

    this.formGroupTopic.patchValue({
      topic,
    });

    this.formGroupTopic
      .get('topic')
      ?.markAsTouched();
  }

  /* =====================================================
     PASSAGGIO ALLA DESCRIZIONE
     ===================================================== */

  public goToDescription(): void {
    if (
      this.formGroupTopic.invalid ||
      !this.selectedTopic
    ) {
      this.formGroupTopic.markAllAsTouched();
      return;
    }

    this.isTopicSelection = false;
  }

  /* =====================================================
     RITORNO ALLA SELEZIONE
     ===================================================== */

  public goBack(): void {
    if (this.submitting) {
      return;
    }

    this.isTopicSelection = true;
  }

  /* =====================================================
     NAVIGAZIONE
     ===================================================== */

  public goToHome(): void {
    if (this.submitting) {
      return;
    }

    this.router.navigate(['/home']);
  }

  /* =====================================================
     CONFERMA E INVIO
     ===================================================== */

  public confirm(): void {
    if (
      this.submitting ||
      !this.selectedTopic ||
      this.formGroupDesc.invalid
    ) {
      this.formGroupDesc.markAllAsTouched();
      return;
    }

    const description = String(
      this.formGroupDesc.get('description')?.value ??
        '',
    ).trim();

    if (!description) {
      this.formGroupDesc
        .get('description')
        ?.setErrors({
          required: true,
        });

      this.formGroupDesc.markAllAsTouched();
      return;
    }

    const request: UserRequest = {
      requestId: Math.floor(
        Math.random() * 1000000000,
      ),
      addDate: new Date(),
      description,
      requester: this.accountService.user!,
      topic: this.selectedTopic,
      status: OpenCloseType.OPEN,
    };

    this.submitting = true;

    this.contactService
      .openRequest(request)
      .subscribe({
        next: () => {
          this.submitting = false;

          // La vecchia dialog eseguiva ref.close(true).
          // Ora, dopo il successo, torniamo alla Home.
          this.router.navigate(['/home']);
        },

        error: (error) => {
          this.submitting = false;

          console.error(
            'Errore invio segnalazione:',
            error,
          );
        },
      });
  }

  /* =====================================================
     STORICO RICHIESTE
     ===================================================== */

  public showPersonalHistory(): void {
    // Funzionalità mantenuta per eventuale uso futuro.
  }
}
